import css from 'styled-jsx/css';

export default css`
  .step-container {
    margin-top: 5%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .card {
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    width: 324px;
    height: 436px;
    margin-right: 15px;
  }
  .card:last-child {
    margin-right: 0;
  }
  .image {
    width: 100%;
    height: 235px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  .description-section {
    text-align: center;
    background-color: #000000;
    background-image: linear-gradient(#0E0E0E, #000000);
    width: 100%;
  }
  .title {
    font-family: 'Eurostile-Bold';
    font-size: 25px;
    text-transform: uppercase;
  }
  .description-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .description {
    font-size: 15px;
    font-family: "Roboto-Normal";
    width: 100%;
    padding-right: 30px;
    padding-left: 30px;
  }
  .mobile-step-carousel {
    overflow: hidden;
    display: none;
  }
  .mobile-card-section {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
    margin-bottom: 20px;
    padding-right: 15px;
    padding-left: 15px;
  }
  .mobile-card {
    width: 377px;
    display: flex;
    justify-content: start;
    align-items: center;
    flex-direction: column;
  }
  .mobile-image {
    height: 250px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  
  @media (max-width: 1220px) {
    .card {
      width: 200px;
    }
  }
  @media (max-width: 900px) {
    .step-container {
      display: none;
    }
    .mobile-step-carousel {
      display: block;
    }
    .description-container {
      padding-bottom: 20px;
    }
    .description {
      font-size: 16px;
    }
    .title {
      padding-right: 20px;
      padding-left: 20px;
      font-size: 26px;
    }
  }
`;